// string 관련 유틸리티

/*
 * desc : url 쿼리 문자열로 변경
 * param : Object
 */
export const queryStringfy = obj => {
  const str = [];
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
  });

  return str.join('&');
};

/*
 * desc : 입력된 문자열이 url 패턴인지 체크
 * param : {
 *           str : String
 *         }
 */
export const checkPatternUrl = str => {
  const expUrl = /^(http\:\/\/)?((\w+)[.])+(asia|biz|cc|cn|com|de|eu|in|info|jobs|jp|kr|mobi|mx|name|net|nz|org|travel|tv|tw|uk|us)(\/(\w*))*$/i;
  return expUrl.test(str);
};
export default {
  queryStringfy,
  checkPatternUrl,
};



// WEBPACK FOOTER //
// ./src/utils/StringUtil.js